import colors from "styles/colors";
import { BACKGROUND_GRAY_COLOR_NAME } from "styles/color-consts";

// docs: https://react-select.com/styles#the-styles-prop

export default function getReactSelectStyles(invalid) {
  const selectStyles = {
    control: (styles) => ({
      ...styles,
      minHeight: "40px",
      borderColor: `${invalid ? colors.red : colors.wolf}`
    }),
    menu: (styles) => ({
      ...styles,
      padding: "8px"
    }),
    option: (styles, state) => ({
      ...styles,
      textAlign: "left",
      padding: "10px 8px 10px 8px",
      color: "black",
      backgroundColor: state.isFocused ? colors[BACKGROUND_GRAY_COLOR_NAME] : "transparent"
    }),
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#DED4FC",
      height: "30px",
      borderRadius: "20px",
      padding: "4px 10px 4px 10px"
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      fontSize: "12px",
      display: "flex",
      alignItems: "center"
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      height: "100%",
      borderRadius: "20px",
      stroke: "rgba(0, 0, 0, 0.7)",
      "&:hover": {
        stroke: "rgba(0, 0, 0, 1)",
        backgroundColor: "transparent"
      }
    }),
    indicatorsContainer: (styles) => ({
      ...styles,
      paddingLeft: "0px"
    }),
    indicatorSeparator: (styles) => ({
      ...styles,
      visibility: "hidden",
      width: "0px"
    })
  };

  return selectStyles;
}
